(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.directive('bigHelpQuestionmark', ['$stateParams', '$translate', '$window', BigHelpQuestionmarkFn]);

    /* small help questionmark directive */
    function BigHelpQuestionmarkFn($stateParams, $translate, $window) {
        var directive = {
            restrict: 'E',
            link: link,
            templateUrl: '/app/help/templates/big-help-questionmark.template.html'
        };
        return directive;

        function link(scope, element) {

            scope.goToCorilus = function (){
                $window.open($translate.instant('url_to_support'), '_blank');
            };
        }
    }
})();